import { ResourceRefOrSchema } from '../../../backend/src/types/common.types'
import { JobTitle } from '../api/job-titles'
import { InterimAgency } from '../api/organizations'
import { compareDocsById } from './documents'

export const getJobTitleInterimAgencySettings = (
  jobTilte: JobTitle,
  interimAgency: ResourceRefOrSchema<InterimAgency>,
): JobTitle['interimAgencySettings'][0] | undefined =>
  jobTilte.interimAgencySettings.find(l => compareDocsById(l.interimAgency, interimAgency))
